import { render, staticRenderFns } from "./LeakInvestigationReportsSearchFilters.vue?vue&type=template&id=96cb40dc"
import script from "./LeakInvestigationReportsSearchFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./LeakInvestigationReportsSearchFilters.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports